export default __webpack_public_path__ + "static/media/img-pool.fc9fbe8e.png";